module.exports = __webpack_public_path__ + "img/VP-ProfiNew_Overview-EC_1.73f79caa.jpg";